export default "__VITE_ASSET__55fa772f__"